// extracted by mini-css-extract-plugin
export default {"container":"PN-z","dimension":"QN-z","dimensionLabels":"RN-z"};